import React from "react";
import { useTranslation } from "react-i18next";
import useSettingsStore, { settingsUpdate } from "../../../App/Stores/SettingsStore";
import CommonButton from "../../../Components/Button/CommonButton";
import CommonInput from "../../../Components/Input/CommonInput";

const AuthorityFee = () => {
  const { t } = useTranslation();

  const { authFee, setAuthFee } = useSettingsStore();

  const handleSubmit = () => {
    if (authFee) {
      settingsUpdate({ type: "auth_fee", value: authFee });
    }
  }
  return (
    <form onSubmit={(e) => e.preventDefault()} className="w-full">
      <div className="pb-5 text-fs20 font-fw600">{t("Service fee")}</div>

      <div className="p-5 bg-white shadow-md rounded-br5">
        <CommonInput
          className="mb-0"
          no_label={true}
          placeholder={t("Enter amount..")}
          type="number"
          required={true}
          value={authFee ?? 0}
          min_number={1}
          onChange={(e) => setAuthFee(e.target.value)}
        />

        <div className="pt-5">
          <CommonButton type="submit" onClick={handleSubmit} btnLabel={t("Save Changes")} colorType="primary" />
        </div>
      </div>
    </form>
  );
};

export default AuthorityFee;
